import { render, staticRenderFns } from "./accountEdit.vue?vue&type=template&id=1c195f93&scoped=true"
import script from "./accountEdit.vue?vue&type=script&lang=js"
export * from "./accountEdit.vue?vue&type=script&lang=js"
import style0 from "./accountEdit.vue?vue&type=style&index=0&id=1c195f93&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c195f93",
  null
  
)

export default component.exports